import React, { ReactNode } from 'react';
import { LinearProgress } from '@mui/material';
import { TitleWithDescription } from '@infoods/lifebase-ui';
import classNames from 'classnames';

import classes from './StepperHeader.module.scss';
import { getPercentages } from '../../../../../../shared/utils/mathUtils';

type StepperHeaderProps = {
  activeStep: number;
  stepsCount: number;
  title: string;
  description?: ReactNode;
  className?: string;
};

const StepperHeader = ({
  activeStep,
  stepsCount,
  title,
  description,
  className,
}: StepperHeaderProps) => {
  const activeStepNumber = activeStep + 1;
  const progress = getPercentages(activeStepNumber, stepsCount);

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classes.headerRow}>
        <TitleWithDescription
          title={title}
          description={description}
          titleFont="title-18-bold"
        />
        <span className={classes.stepCounter}>
          Step {activeStepNumber} of {stepsCount}
        </span>
      </div>
      <LinearProgress
        variant="determinate"
        value={progress}
        className={classes.progressBar}
      />
    </div>
  );
};

export { StepperHeader };
